/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Jinhyoung Jang (jangjh@rsupport.com)
 *
 * @description
 *
 * @created at 2024-07-30 17:43:22
 **/
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */

import { PropsWithChildren, useEffect, useRef } from "react";
import isEmpty from "lodash-es/isEmpty";
import has from "lodash-es/has";

import { Configure, each, Utility } from "@/frameworks/libraries/utilities";

import { useAPIState } from "@/frameworks/core/hooks";
import { useUsers } from "@/frameworks/core/API";
import { usePersistActions, usePersistStore } from "@/frameworks/core/persistence";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const LOGTAG = "#StorageProvider#";

export default function StorageProvider(props: PropsWithChildren) {
	const is_initialized = useRef(false);
	const users = usePersistStore((state) => state.users);
	const dispatch = usePersistActions();
	const userAPI = useUsers();

	// 내 정보 변경 시 사용자 정보도 같이 갱신
	useAPIState<WebServices.User.Me.Update.Response>(userAPI.me.update, {
		onSuccess(result: WebServices.User.Me.Update.Response) {
			result.data && dispatch.users.set_user(Configure.userID, result.data);
		}
	});

	useAPIState<WebServices.UserActiveStatus.Update.Response>(userAPI.userActiveStatus.update, {
		onSuccess(result: WebServices.UserActiveStatus.Update.Response) {
			console.debug(LOGTAG, "UserActiveStatus: manual update");
		}
	});
	useAPIState<WebServices.UserActiveStatus.Active.Response>(userAPI.userActiveStatus.system_active, {
		onSuccess(result: WebServices.UserActiveStatus.Active.Response) {
			console.debug(LOGTAG, "UserActiveStatus: system_active");
		}
	});
	useAPIState<WebServices.UserActiveStatus.Away.Response>(userAPI.userActiveStatus.system_away, {
		onSuccess(result: WebServices.UserActiveStatus.Away.Response) {
			console.debug(LOGTAG, "UserActiveStatus: system_away");
		}
	});

	const initialize_storage = async () => {
		if (!is_initialized.current) {
			is_initialized.current = true;
			console.groupCollapsed(LOGTAG, "Initialize Storage Provider...");
			dispatch.initialize().then(() => {
				console.groupEnd();
			});

			// usePersistStore.subscribe((state, prevState) => {
			// 	try {
			// 		each(state.users, (key, value) => {
			// 			const diff = Utility.get_difference(value, prevState.users[key]);
			// 			if (!isEmpty(diff)) {
			// 				if (!(Object.keys(diff).length === 1 && has(diff, "timestamp"))) {
			// 					console.debug(LOGTAG, `User State changed`, { id: key, name: value.name, ...diff });
			// 				}
			// 			}
			// 		});
			// 	} catch (error) {
			// 		console.warn(LOGTAG, "Failed to get difference", error);
			// 	}
			// });
		}
	};

	useEffect(() => {
		initialize_storage().then(() => {});
	}, [users]);

	return <>{props.children}</>;
}
